namespace Areas {
    "use strict";

    export class Tab {
        id: number;
        url: string;

        constructor(id: number, url: string) {
            this.id = id;
            this.url = url;
        }
    }
    export function createTabsWithSameActionAndDifferentAreas(action: string, controllersWithArea: string[]): Array<Tab> {
        return controllersWithArea.map((value, index) => new Tab(index, `/${value}/${action}`));
    }


    export function createTabsWithSameAction(area: string, action: string, controllers: string[]): Array<Tab> {
        return controllers.map((value, index) => new Tab(index, `/${area}/${value}/${action}`));
    }

    export function createTabsWithSameController(area: string, actions: string[], controller: string): Array<Tab> {
        return actions.map((value, index) => new Tab(index, `/${area}/${controller}/${value}`));
    }

    export function tabInitialized(tabItems: Tab[]) {
        return tabInitializedBase(tabItems, i => new Tab(i.id, i.url));
    }  

    export function tabItemClick(params: any) {
        window.location.href = params.itemData.url;
    } 

    export function tabWithIdInitialized(tabItems: Tab[]) {
        return tabInitializedBase(tabItems, (i, tabControl) => new Tab(i.id, `${i.url}/${tabControl.option("id")}`));
    }

    export function tabWithIdItemClick(params: any) {
        const url = params.itemData.url + "/" + params.component.option("id");
        window.location.href = url;
    }   
    
    function tabInitializedBase(tabItems: Tab[], transform: (t: Tab, tabControl: DevExpress.ui.dxTabs) => Tab) {
        return (params: any) => {
            const tabControl: DevExpress.ui.dxTabs = params.component;
            const currentUrl = window.location.pathname;

            matchTabWithExactUrl(tabItems, transform, tabControl, currentUrl);
            selectParentTab(tabControl);
       }
    }

    function selectParentTab(tabControl: DevExpress.ui.dxTabs) {
        const parentTabId = tabControl.option("parentTabId");
        const parentSelectedIndex:number = tabControl.option("parentSelectedIndex") as number;

        if (isNotEmpty(parentTabId) && isNotEmpty(parentSelectedIndex)) {
            const parentTab: DevExpress.ui.dxTabs = $(`#${parentTabId}`).dxTabs("instance");

            if (parentTab) {
                parentTab.option("selectedIndex", parentSelectedIndex);
            }
        }
    }
    
    function matchTabWithExactUrl(tabItems: Tab[], transform: (t: Tab, tabControl: DevExpress.ui.dxTabs) => Tab,
        tabControl:DevExpress.ui.dxTabs, currentUrl: string) {

        if (currentUrl.indexOf("Account/Schedule") > 0 ) {
            currentUrl = currentUrl.substring(0, currentUrl.lastIndexOf("/"))
        }

   

        const selectedTab = tabItems
        .map(i => transform(i, tabControl))
        .filter((element) => currentUrl === element.url);

        if (selectedTab.length === 1) {
            tabControl.option("selectedIndex", selectedTab[0].id);
        }
    }        
    
}
